import { render, staticRenderFns } from "./AttendanceRequests.vue?vue&type=template&id=1792b774"
import script from "./AttendanceRequests.vue?vue&type=script&lang=js"
export * from "./AttendanceRequests.vue?vue&type=script&lang=js"
import style0 from "./AttendanceRequests.vue?vue&type=style&index=0&id=1792b774&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports